var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import cn from 'classnames';
import { extractSupportProps } from '@snack-uikit/utils';
import { ORIENTATION, WEIGHT } from './constants';
import styles from './styles.module.css';
/** Компонент для визуального отделения групп компонентов */
export function Divider(_a) {
    var { className, orientation = ORIENTATION.Horizontal, weight = WEIGHT.Regular } = _a, rest = __rest(_a, ["className", "orientation", "weight"]);
    const commonProps = Object.assign(Object.assign({}, extractSupportProps(rest)), { 'data-weight': weight });
    return orientation === ORIENTATION.Horizontal ? (_jsx("hr", Object.assign({ className: cn(styles.horizontal, className) }, commonProps))) : (_jsx("div", Object.assign({ className: cn(styles.vertical, className) }, commonProps)));
}
